import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FootNotesService {

  private JCD_KEY = 250;

  constructor(private http: HttpClient) {}

  getForms(pdfEngineUrl: string, taxYear: string, filingType: string, systemFlag: string): Observable<any> {
    const url = `${pdfEngineUrl}/getFootNoteForms?tax_year=${taxYear}&filing_type=${filingType}&system_flag=${systemFlag}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  getPartners(pdfEngineUrl: string, taxYear: string, scenario: string, leid: string, cdrNo: string, rptPrd: string): Observable<any> {
    const url = `${pdfEngineUrl}/getPartners?tax_year=${taxYear}&scenario=${scenario}&jcd_key=${this.JCD_KEY}&leid=${leid}&cdr_no=${cdrNo}&reporting_period=${rptPrd}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  getFootNotes(
    pdfEngineUrl: string, taxYear: string, scenario: string, jcdKey: number,
    leId: string, cdrNo: string, rptPrd: string, formSub: string | null,
    formName: string, schedule: string
  ): Observable<any[]> {
    if (schedule === 'NA') formSub = null;
    const url = `${pdfEngineUrl}/getFootNotes?taxYear=${taxYear}&scenario=${scenario}&jcdKey=${jcdKey}&leId=${leId}&cdrNo=${cdrNo}&reporting_period=${rptPrd}&formSub=${formSub}&formName=${formName}&schedule=${schedule}`;
    return this.http.get<any>(url, { withCredentials: true }).pipe(
      map(response => {
        if (response.callSuccess === '1') {
          return response.footNotes;
        }
        if (response.errorMessage) {
          console.error(response.errorMessage);
        }
        return null;
      })
    );
  }

  getFootNote(pdfEngineUrl: string, footNoteId: number): Observable<any> {
    const url = `${pdfEngineUrl}/getFootNote?footNoteId=${footNoteId}`;
    return this.http.get<any>(url, { withCredentials: true }).pipe(
      map(response => {
        if (response.callSuccess === '1') {
          return response.footNote;
        }
        if (response.errorMessage) {
          console.error(response.errorMessage);
        }
        return null;
      })
    );
  }

  saveFootNote(
    pdfEngineUrl: string, noteId: number | null, noteName: string,
    taxYear: string, scenario: string, meCode: string,
    leid: string, cdrNo: string, rptPrd: string,
    formSub: string | null, formName: string, schedule: string,
    htmlData: string, isTemplate: string
  ): Observable<any> {
    const url = `${pdfEngineUrl}/saveFootNote`;
    const body = {
      note_id: noteId,
      note_name: noteName,
      tax_year: taxYear,
      scenario: scenario,
      me_code: meCode,
      leid: leid,
      cdr_no: cdrNo,
      reporting_period: rptPrd,
      form_sub: formSub,
      form_name: formName,
      schedule: schedule,
      html_data: htmlData,
      is_template: isTemplate,
      jcd_key: this.JCD_KEY
    };
    return this.http.post<any>(url, body, { withCredentials: true });
  }

  deleteNote(pdfEngineUrl: string, footNoteId: number): Observable<any> {
    const url = `${pdfEngineUrl}/deleteFootNote?footNoteId=${footNoteId}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  getViewForDropdown(pdfEngineUrl: string, taxYear: string, scenario: string, category: string, srcSystemFlag: string, leType: string): Observable<any> {
    const url = `${pdfEngineUrl}/getViewForDropdown?taxYear=${taxYear}&scenario=${scenario}&jcdKey=${this.JCD_KEY}&leType=${leType}&src_system_flag=${srcSystemFlag}&business_type=${category}`;
    return this.http.post<any>(url, null, { withCredentials: true });
  }

  exportPdf(pdfEngineUrl: string, footNoteContent: string): Observable<any> {
    const url = `${pdfEngineUrl}/getFootNotePDF`;
    return this.http.post(url, { footNoteContent }, { responseType: 'arraybuffer', withCredentials: true }).pipe(
      map(data => {
        const file = new Blob([data], { type: 'application/pdf' });
        const pdfPath = URL.createObjectURL(file);
        const a = document.createElement('a');
        a.href = pdfPath;
        a.target = '_blank';
        a.click();
        return data;
      })
    );
  }
}
